import { render, staticRenderFns } from "./day-configurator-date-modal.vue?vue&type=template&id=2357437a&scoped=true&"
import script from "./day-configurator-date-modal.vue?vue&type=script&lang=js&"
export * from "./day-configurator-date-modal.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-date-modal.vue?vue&type=style&index=0&id=2357437a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357437a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2357437a')) {
      api.createRecord('2357437a', component.options)
    } else {
      api.reload('2357437a', component.options)
    }
    module.hot.accept("./day-configurator-date-modal.vue?vue&type=template&id=2357437a&scoped=true&", function () {
      api.rerender('2357437a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/modals/day-configurator-date-modal.vue"
export default component.exports